module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'is-margin': _vm.sidebar
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "disable-select",
    class: {
      'backgroundImg': _vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.path === '/onBoard' || _vm.$route.path.indexOf('/onBoardMember') !== -1) ? true : false),
      expression: "($route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1)? true : false"
    }],
    staticClass: "backgroundUpperLayer"
  }), _vm._v(" "), _c('nprogress-container'), _vm._v(" "), _c('navbar', {
    attrs: {
      "show": true,
      "expand": _vm.sidebar,
      "sidebar": _vm.sidebar
    },
    on: {
      "update:sidebar": function($event) {
        _vm.sidebar = $event
      }
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "sidebarShow": _vm.sidebar,
      "sidebar": _vm.sidebar
    },
    on: {
      "update:sidebar": function($event) {
        _vm.sidebar = $event
      }
    }
  }), _vm._v(" "), _c('app-main'), _vm._v(" "), _c('footer-bar')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91f9068c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/App.vue
// module id = 380
// module chunks = 5